import React from "react"
import { wrapPage } from "../../aggregators/page"
import BrandsPageContainer from "../../containers/brands"
import { fetchGroupedBrandPages } from "../../contents/brands/fetch"
import { brandsPageDataQuery } from "../../contents/brands/queries"
import { BrandLetterGroups } from "../../contents/brands/types"
import { SeoContents } from "../../features/seo/components/PageSEO"
import { DefaultLayout } from "../../layouts/Default/DefaultLayout"
import { WrapPage } from "../../root"
import { getClient } from "../../root/sanity/client"
import { sanitizeNextObject } from "../../utils/serialization"

interface Props {
  contents: any
  brands: BrandLetterGroups
  languageId: string
  rootData: any
}

export default function BrandPage({
  // languageId,
  contents: data,
  rootData,
  brands,
}: Props) {
  return (
    <WrapPage rootData={rootData}>
      <DefaultLayout>
        <BrandsPageContainer contents={data} brands={brands} />
      </DefaultLayout>
      <SeoContents page={data} />
    </WrapPage>
  )
}

export async function getServerSideProps({ params, locale }: any) {
  return await wrapPage({
    locale,
    fetchProps: async (languageId: string) => {
      const contents = await getClient().fetch(brandsPageDataQuery, {
        locale: languageId,
      })
      const brands = await fetchGroupedBrandPages(languageId)
      return {
        contents: sanitizeNextObject(contents),
        brands: sanitizeNextObject(brands),
      }
    },
  })
}
